module.exports = __webpack_public_path__ + "static/img/RASR4_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RASR4_1.png
// module id = tmIz
// module chunks = 0